import { type CreateApplicationConfigInputType } from '@shelflix/schemas/applicationConfig/create';
import { create } from 'zustand';

interface ApplicationConfig {
  formData: Partial<CreateApplicationConfigInputType>;
  setFormData: (data: Partial<CreateApplicationConfigInputType>) => void;
  resetForm: () => void;
}

export const useApplicationConfig = create<ApplicationConfig>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
